import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { SearchItem } from '@rivethealth/data/ui-search-item';
import { AnchoredPosition } from '../callout/callout-position';
import { Chip } from './chip-input.component';

@Component({
  selector: 'chip-dropdown',
  styleUrls: ['./chip-dropdown.component.scss'],
  templateUrl: './chip-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipDropdownComponent {
  @Input() up: boolean = false;

  @Input() text: string;

  @Input() chips: Chip[] = [];

  @Input() placeholder: string;

  @Input() search: (term: string) => Promise<SearchItem[]>;

  @Input() isValid: (chip: Chip) => boolean = () => true;

  @Output() rvChange = new EventEmitter<SearchItem[]>();

  expanded = false;

  AnchoredPosition = AnchoredPosition;
}
